
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/headless",
      function () {
        return require("private-next-pages/headless.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/headless"])
      });
    }
  